'use strict';

var _ = require('lodash');
var NewCalibrationAnalysisService = function NewCalibrationAnalysisService(restangular, momentConstants) {
  var apiUrl = '/domain/logitCalibration/request';
  function getServiceUrl() {
    return restangular.service(apiUrl);
  }
  function getOriginAndDestination(marketObject) {
    var originAndDestination = _.split(marketObject.market, '-');
    return {
      origin: originAndDestination[0],
      destination: originAndDestination[1]
    };
  }
  function setMarketsForRequest(markets) {
    return _.chain(markets).filter('selected').map(getOriginAndDestination).value();
  }
  function sendNewCalibrationAnalysisRequest(calibrationAnalysis) {
    var request = prepareRequest(calibrationAnalysis);
    return getServiceUrl().post(request);
  }
  function prepareRequest(calibrationAnalysis) {
    return {
      calibrationName: _.trim(calibrationAnalysis.calibrationName),
      metric: calibrationAnalysis.metric,
      startDate: calibrationAnalysis.dateRangeFrom.format(momentConstants.FORMATS.DATE_ISO),
      endDate: calibrationAnalysis.dateRangeTo.format(momentConstants.FORMATS.DATE_ISO),
      markets: setMarketsForRequest(calibrationAnalysis.selectedMarkets),
      shareReviewStartDate: calibrationAnalysis.shareReviewDateRangeFrom.format(momentConstants.FORMATS.DATE_ISO),
      shareReviewEndDate: calibrationAnalysis.shareReviewDateRangeTo.format(momentConstants.FORMATS.DATE_ISO),
      travelTimeBucketWidth: calibrationAnalysis.travelTimeBucketWidth,
      fareBucket: calibrationAnalysis.fareBucket
    };
  }
  return {
    sendNewCalibrationAnalysisRequest: sendNewCalibrationAnalysisRequest
  };
};
NewCalibrationAnalysisService.$inject = ['Restangular', 'MomentConstants'];
module.exports = NewCalibrationAnalysisService;